import { getDiallable, isNativeApp, openExternal } from '../myFunctions';

// עוטף את התוכן בקישור חיוג - אבל רק כשבשדה באמת יש מספר.
// שדה הטלפון של המסעדה הוא טקסט חופשי, ולפעמים מוזן בו טקסט ("הזמנות דרך האתר בלבד")
// לפי החלטה תפעולית שמשתנה בין מסעדות. במקרה כזה מציגים את התוכן כמו שהוא, בלי קישור,
// כדי שלא ייווצר קישור לחיץ שמנסה לחייג לטקסט.
const PhoneLink = (props) => {
    const dial = getDiallable(props.phone);

    // עטיפה ב-Fragment ולא החזרת props.children ישירות: כשאין children הערך הוא
    // undefined, וקומפוננטה שמחזירה undefined מפילה את React (שגיאה 152) ואיתה את
    // כל עץ האפליקציה. Fragment הוא תמיד אלמנט תקין, ו-undefined בתוכו לא מרנדר כלום.
    if (!dial) return <>{props.children}</>;

    return (
        <a className={props.className}
            href={isNativeApp() ? "#" : `tel:${dial}`}
            onClick={isNativeApp() ? (e) => { e.preventDefault(); openExternal(`tel:${dial}`, dial, 'המספר הועתק - פתחו את החייגן והדביקו'); } : undefined}>
            {props.children}
        </a>
    );
};

export default PhoneLink;
